// Позиции скролла по ключу записи истории (web/SPA). Кормится платформенным адаптером;
// на native не используется. Ключ уникален на запись: PUSH → новый ключ (нет позиции → топ),
// POP → прежний ключ (позиция есть → восстановление).
const MAX_ENTRIES = 100

let currentHistoryKey = 'initial'
const positions = new Map<string, number>()

function composeId(historyKey: string, scopeId: string): string {
  return `${historyKey}::${scopeId}`
}

export function setScrollHistoryKey(historyKey: string): void {
  currentHistoryKey = historyKey
}

export function saveScrollPosition(scopeId: string, offset: number): void {
  const id = composeId(currentHistoryKey, scopeId)

  if (!positions.has(id) && positions.size >= MAX_ENTRIES) {
    const oldest = positions.keys().next().value

    if (oldest !== undefined) positions.delete(oldest)
  }

  positions.set(id, offset)
}

export function readScrollPosition(scopeId: string): number | undefined {
  return positions.get(composeId(currentHistoryKey, scopeId))
}
